<template>
  <v-card
    class="mx-auto"
    width="260"
    flat
    :style="{
      background:
        theme.cardBodyBg,
      color:
        theme.cardBodyColor
    }"
  >
    <!-- SEARCH -->
    <v-text-field
      v-model="search"
      :label="t('search')"
      variant="outlined"
      density="compact"
      class="m-2"
      clearable
      style="margin-top: 20px; width: 245px; margin-left: 5px;"
      :style="{
        ...sysTypo.sectionTypography.input,
        color:
          theme.cardBodyColor
      }"
    />

    <!-- MENU -->
    <v-list
      v-model:opened="open"
      :style="{
        background:
          theme.cardBodyBg,
        color:
          theme.cardBodyColor
      }"
    >
      <template
        v-for="(item, idx) in filteredMenu"
        :key="idx"
      >

        <!-- GROUP -->
        <v-list-group
          v-if="item.children"
          :value="item.id"
        >
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              :prepend-icon="item.icon"
              :title="item.title"
              class="menu-colored"
              :style="{
                ...sysTypo.sectionTypography.body,
                background:
                  theme.cardTitleBgColor,
                color:
                  theme.cardTitleTextColor
              }"
            />
          </template>

          <!-- CHILDREN -->
          <template
            v-for="(child, cIdx) in item.children"
            :key="cIdx"
          >

            <!-- SUB-GROUP -->
            <v-list-group
              v-if="child.children"
              :value="child.id"
            >
              <template #activator="{ props }">
                <v-list-item
                  v-bind="props"
                  :title="child.title"
                  class="menu-colored"
                  :style="{
                    ...sysTypo.sectionTypography.body,
                    background:
                      theme.cardTitleBgColor,
                    color:
                      theme.cardTitleTextColor
                  }"
                />
              </template>

              <v-list-item
                v-for="sub in child.children"
                :key="sub.id"
                :title="sub.title"
                :append-icon="sub.icon"
                link
                :to="sub.to"
                :class="{
                  'active-item':
                    route.path ===
                    sub.to
                }"
                :style="{
                  ...sysTypo.sectionTypography.body,
                  color:
                    theme.cardBodyColor
                }"
              />
            </v-list-group>

            <!-- NORMAL ITEM -->
            <v-list-item
              v-else
              :title="child.title"
              :append-icon="child.icon"
              link
              :to="child.to"
              :class="{
                'active-item':
                  route.path ===
                  child.to
              }"
              :style="{
                ...sysTypo.sectionTypography.body,
                color:
                  theme.cardBodyColor
              }"
            />
          </template>
        </v-list-group>

        <!-- NORMAL ROOT ITEM -->
        <v-list-item
          v-else
          :append-icon="item.icon"
          :title="item.title"
          link
          :to="item.to"
          :class="{
            'active-item':
              route.path ===
              item.to
          }"
          :style="{
            ...sysTypo.sectionTypography.body,
            color:
              theme.cardBodyColor
          }"
        />
      </template>
    </v-list>
  </v-card>
</template>

<script setup>
import {
  ref,
  watch,
  computed
} from "vue"

import {
  useRoute,
  useRouter
} from "vue-router"

import {
  useLangStore
} from '@/store/lang'

import {
  useAuthStore,
  useThemeStore
} from "@/store/auth"

import {
  useSysTypo
} from "@/store/useSysTypo"

import {
  useI18n
} from 'vue-i18n'

const {
  t
} = useI18n()

const lang =
  useLangStore()

const auth =
  useAuthStore()

const themeStore =
  useThemeStore()

const sysTypo =
  useSysTypo()

const route =
  useRoute()

const router =
  useRouter()

// ============================================================
// THEME
// ============================================================

const theme =
  computed(
    () =>
      themeStore.sectionTheme ||
      {}
  )

// SEARCH
const search =
  ref("")

const open =
  ref([])


/* -------------------------------------------------------
   REACTIVE MENU (updates when lang changes)
------------------------------------------------------- */
const menu =
  computed(() => [
    {
      id:
        "admin-section",

      title:
        lang.currentLanguage === "en"
          ? "Administration"
          : "Administration",

      icon:
        "mdi-shield-account",

      children: [
        {
          id:
            "uc-4",

          title:
            lang.currentLanguage === "en"
              ? "Take assessment"
              : "Take assessment",

          icon:
            "mdi-plus-outline",

          to:
            router.resolve({
              name:
                lang.currentLanguage === 'en'
                  ? "assessmentEN"
                  : "assessmentFR"
            }).href,

          permission:
            "ASSESSMENT.VIEW"
        },
      ]
    },

    {
      id:
        "my-profile",

      title:
        lang.currentLanguage === "en"
          ? "Profile"
          : "monProfile",

      icon:
        "mdi-shield-account",

      children: [
        {
          id:
            "uc-2",

          title:
            lang.currentLanguage === "en"
              ? "Edit profile"
              : "Edit profile",

          icon:
            "mdi-plus-outline",

          to:
            router.resolve({
              name:
                lang.currentLanguage === 'en'
                  ? "EditProfileEN"
                  : "EditProfileFR"
            }).href,

          permission:
            "MESSAGE.CREATE"
        },

        {
          id:
            "uc-3",

          title:
            lang.currentLanguage === "en"
              ? "My messages"
              : "Mon messsage",

          icon:
            "mdi-plus-outline",

          to:
            router.resolve({
              name:
                lang.currentLanguage === 'en'
                  ? "MessagingEN"
                  : "MessagingFR"
            }).href,

          permission:
            "MESSAGE.CREATE"
        },
      ]
    },

    {
      id:
        "my-dashboard",

      title:
        lang.currentLanguage === "en"
          ? "Assessment"
          : "Assessment",

      icon:
        "mdi-shield-account",

      children: [
        {
          id:
            "uc-2",

          title:
            lang.currentLanguage === "en"
              ? "Take assessment"
              : "Take assessment",

          icon:
            "mdi-plus-outline",

          to:
            router.resolve({
              name:
                lang.currentLanguage === 'en'
                  ? "assessmentEN"
                  : "assessmentFR"
            }).href,

          permission:
            "ASSESSMENT.VIEW"
        },
      ]
    }
  ])


/* -------------------------------------------------------
   PERMISSION FILTERING
------------------------------------------------------- */

function canAccessItem(
  item
) {
  if (
    !item
  ) {
    return false
  }

  if (
    item.public === true
  ) {
    return true
  }

  if (
    item.permission &&
    !auth.hasPermission(
      item.permission
    )
  ) {
    return false
  }

  return true
}

function filterByAccess(
  items
) {
  return (
    items || []
  )
    .map(
      item => {
        if (
          !canAccessItem(
            item
          )
        ) {
          return null
        }

        if (
          item.children?.length
        ) {
          const children =
            filterByAccess(
              item.children
            )

          if (
            children.length === 0
          ) {
            return item.to
              ? {
                  ...item,
                  children:
                    undefined
                }
              : null
          }

          return {
            ...item,
            children
          }
        }

        return item
      }
    )
    .filter(Boolean)
}


/* -------------------------------------------------------
   COLLECT GROUP IDS
------------------------------------------------------- */

function collectGroupIds(
  items,
  results = []
) {
  (
    items || []
  )
    .forEach(
      item => {
        if (
          item.children?.length
        ) {
          results.push(
            item.id
          )

          collectGroupIds(
            item.children,
            results
          )
        }
      }
    )

  return results
}


/* -------------------------------------------------------
   FILTER WITH PERMISSIONS
------------------------------------------------------- */

function filterItems(
  items,
  query
) {
  const q =
    String(
      query || ""
    )
      .trim()
      .toLowerCase()

  return (
    items || []
  )
    .map(
      item => {
        if (
          !canAccessItem(
            item
          )
        ) {
          return null
        }

        const match =
          !q ||
          String(
            item.title || ""
          )
            .toLowerCase()
            .includes(q)

        if (
          item.children?.length
        ) {
          const filteredChildren =
            filterItems(
              item.children,
              q
            )

          if (
            filteredChildren.length >
            0
          ) {
            return {
              ...item,
              children:
                filteredChildren
            }
          }

          if (
            match
          ) {
            return {
              ...item,
              children:
                filterByAccess(
                  item.children
                )
            }
          }

          return null
        }

        return match
          ? item
          : null
      }
    )
    .filter(Boolean)
}

const visibleMenu =
  computed(() =>
    filterByAccess(
      menu.value
    )
  )

const filteredMenu =
  computed(() =>
    filterItems(
      visibleMenu.value,
      search.value
    )
  )


/* -------------------------------------------------------
   KEEP GROUPS SYNCHRONIZED
------------------------------------------------------- */

watch(
  visibleMenu,
  items => {
    if (
      !search.value
    ) {
      open.value =
        collectGroupIds(
          items
        )
    }
  },
  {
    immediate:
      true
  }
)


/* -------------------------------------------------------
   EXPAND GROUPS ON SEARCH
------------------------------------------------------- */

watch(
  search,
  () => {
    if (
      !search.value
    ) {
      open.value =
        collectGroupIds(
          visibleMenu.value
        )

      return
    }

    open.value =
      collectGroupIds(
        filteredMenu.value
      )
  }
)
</script>

<style scoped>
/* Your original styles preserved */
.v-list-item {
  padding-left: 8px !important;
  min-height: 32px !important;
}

.v-list-item__prepend {
  margin-right: 6px !important;
}

.v-list-group__items .v-list-item {
  padding-left: 16px !important;
}

.v-list-group__items .v-list-group__items .v-list-item {
  padding-left: 20px !important;
}

.v-list-group__header {
  padding-left: 8px !important;
  min-height: 32px !important;
}

.v-list-item-title {
  color: #1976d2 !important;
  font-size: 14px;
}

.menu-colored {
  margin-top: 2px;
}

.active-item {
  background-color: rgba(25, 118, 210, 0.2) !important;
  color: #1976d2 !important;
  font-weight: bold;
}

.active-item .v-list-item__prepend .v-icon {
  color: #1976d2 !important;
}
</style>
